<div style="height: min-content" class="access-unavailable">
  <div class="modal-header lead fw-bold mt-2" translate>Access Unavailable</div>
  <div class="modal-body">
    Your user account is not linked to a customer with access to the AMC (Agile Management Center).
    Please search for a specific customer or sign in with a different account. For additional
    assistance, please contact your service team.
  </div>
  <div class="d-flex gap-3">
    <button type="button" class="button-modal no btn" (click)="signOut()">Sign Out</button>
    <button type="button" class="btn button-modal btn-primary me-3" (click)="closeIcon()">
      Change Customer
    </button>
  </div>
</div>
